import React, {useCallback, useEffect, useRef, useState} from "react";

import {connect} from "react-redux";
import {useLocation} from "react-router-dom";
import {CloseOutlined, MenuOutlined} from "@ant-design/icons";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth
} from "../../store/actions";

// Layout Related Components
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { pageTitle } from "constants/pageTitles";

const Layout = ({
                  toggleRightSidebar,
                  changeSidebarType,
                  changeSidebarTheme,
                  changeLayoutWidth,
                  changeTopbarTheme,
                  location,
                  children,
                  leftSideBarType,
                  leftSideBarTheme,
                  layoutWidth,
                  topbarTheme,
                  showRightSidebar
                }) => {
  const [isMobile] = useState(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent))
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const {pathname} = useLocation()
  const isInitialMount = useRef(true)

  useEffect(() => {
    // Scroll Top to 0
    window.scrollTo(0, 0);
    document.title = pageTitle(pathname);
    if (isInitialMount.current) {
      if (leftSideBarTheme) {
        changeSidebarTheme(leftSideBarTheme);
      }

      if (layoutWidth) {
        changeLayoutWidth(layoutWidth);
      }

      if (leftSideBarType) {
        changeSidebarType(leftSideBarType);
      }
      if (topbarTheme) {
        changeTopbarTheme(topbarTheme);
      }

      if (showRightSidebar) {
        toggleRightSidebar();
      }
      isInitialMount.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deliberately re-runs only on navigation (`location`); the theme/layout setters are applied once via the `isInitialMount` ref, and depending on them too would re-trigger the scroll/title reset on unrelated redux state changes.
  }, [location])

  // Below 992px the sidebar only shows while body has `sidebar-enable` (_vertical.scss).
  useEffect(() => {
    document.body.classList.toggle("sidebar-enable", isMenuOpen)
    return () => document.body.classList.remove("sidebar-enable")
  }, [isMenuOpen])

  useEffect(() => {
    setIsMenuOpen(false)
  }, [pathname])

  // A tap on the current page's link doesn't change the pathname, so close on
  // the tap itself. `#` links only expand a submenu and keep the menu open.
  const closeMenuOnLinkTap = useCallback(({target}) => {
    const link = target.closest("a")
    if (link && !link.hash) {
      setIsMenuOpen(false)
    }
  }, [])

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <header className="mobile-topbar">
          <button type="button"
                  className="mobile-topbar-toggle"
                  aria-label={isMenuOpen ? "Затвори менюто" : "Меню"}
                  aria-expanded={isMenuOpen}
                  onClick={() => setIsMenuOpen(open => !open)}>
            {isMenuOpen ? <CloseOutlined/> : <MenuOutlined/>}
          </button>
        </header>
        <Sidebar theme={leftSideBarTheme}
                 type={leftSideBarType}
                 isMobile={isMobile}
                 onClick={closeMenuOnLinkTap}/>
        <div className="vertical-menu-backdrop" onClick={() => setIsMenuOpen(false)}/>
        <div className="main-content">
          {children}
        </div>
        <Footer/>
      </div>
    </React.Fragment>
  );
}


const mapStatetoProps = state => {
  return {
    ...state.Layout
  };
};
export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth
})(Layout)

